export const PRICE_PER_MONTH = 5000;
export const OrderPrice = 2000;
